<template>
    <v-row justify="center">

        <v-dialog
            v-model="dialog"
            max-width="390"
        >
            <v-card>
                <v-card-title class="headline"><div style="text-align: center; width: 100%;">{{ title }}</div></v-card-title>

                <v-card-text>
                    <div style="text-align: center" v-html="text"></div>
                </v-card-text>

                <v-card-actions>

                <v-btn
                    color="green darken-1"
                    text
                    block
                    @click="closeDialog()"
                >
                    Закрыть окно
                </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        data () {
            return {
                dialog: false,
                title: '',
                text: ''
            }
        },
        props: {
        },
        methods: {
            openDialog(dataText) {
                this.title = dataText.title
                this.text = dataText.text

                this.dialog = true
            },
            closeDialog() {
                this.dialog = false
            },
        }
    }
</script>